import { z } from 'zod'
import { contextFormSchema, contextKindSchema, contextRelationTypeSchema } from '../../shared/coreContracts'

export const interpretationCandidateSchema = z.object({
  tempId: z.string().min(1),
  existingRecordId: z.string().min(1).nullable(),
  form: contextFormSchema,
  kind: contextKindSchema,
  title: z.string().min(1),
  summary: z.string().min(1).nullable(),
  tydyCommentary: z.string().min(1).nullable(),
  observedAt: z.string().nullable(),
  confidence: z.number().min(0).max(1),
  evidenceQuote: z.string().min(1),
})

export const interpretationRelationSchema = z.object({
  fromTempId: z.string().min(1),
  toTempId: z.string().min(1),
  relation: contextRelationTypeSchema,
  confidence: z.number().min(0).max(1),
  evidenceQuote: z.string().min(1),
})

export const captureInterpretationProposalSchema = z.object({
  intent: z.enum(['context', 'action', 'mixed', 'no_change']),
  candidates: z.array(interpretationCandidateSchema),
  relations: z.array(interpretationRelationSchema),
  action: z.object({
    title: z.string().min(1),
    confidence: z.number().min(0).max(1),
    evidenceQuote: z.string().min(1),
    consequential: z.boolean(),
  }).nullable(),
  confidence: z.number().min(0).max(1),
  reason: z.string().min(1),
})

export const captureInterpretationResponseSchema = z.object({
  success: z.literal(true),
  proposal: captureInterpretationProposalSchema,
  usage: z.object({
    model: z.string().min(1),
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    estimatedCostMicros: z.number().int().nonnegative(),
    monthCalls: z.number().int().nonnegative(),
    monthLimit: z.number().int().positive(),
  }),
})

export const captureInterpretationUsageResponseSchema = z.object({
  success: z.literal(true),
  usage: z.object({
    monthCalls: z.number().int().nonnegative(),
    monthLimit: z.number().int().positive(),
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    estimatedCostMicros: z.number().int().nonnegative(),
  }),
})

export type CaptureInterpretationProposal = z.infer<typeof captureInterpretationProposalSchema>
export type CaptureInterpretationResponse = z.infer<typeof captureInterpretationResponseSchema>
export type CaptureInterpretationUsageResponse = z.infer<typeof captureInterpretationUsageResponseSchema>
